import { regex } from './common'
export default regex('email', /^[\w\d-!#$%&'*+/=?^`{|}]+(\.[\w\d-!#$%&'*+/=?^`{|}]+)*@[\w\d {\/\-}]+(\.[\w\d-]+)*(\.[a-zA-Z]{2,})$/)
